const t={behavior:"smooth",block:"start",inline:"start"},o={behavior:"auto",block:"start",inline:"start"};export{o as Jump,t as Smooth};
//# sourceMappingURL=scrolling-options.js.map
